<template>
  <div class="aisea-p-6">
    <div class="vx-auto-suggest">
      <div class="flex items-center relative search-form-box">
        <vs-input
          ref="input"
          :placeholder="placeholder"
          class="w-full search-form"
          icon-pack="feather"
          icon="icon-search"
          icon-no-border
          :value="keyword"
          @input="handleInput"
        />
        <feather-icon-button
          class="search-form-x-icon"
          :class="{ visible: isInput }"
          :clickFunction="deleteWord"
          iconName="XIcon"
        />
      </div>
    </div>
  </div>
</template>

<script>
/**
 * インクリメンタルサーチを行うフォームのコンポーネント、インクリメンタルサーチを行う箇所では本コンポーネントを使う想定
 * @parent O.EquipmentBaseStation
 * @parent O.OwnVessel
 * @parent O.SelectedVessel
 * @parent O.VesselEquipmentBaseStations
 * @props placeholder: String フォームのプレースホルダ
 * @props keyword: String 入力されるワード
 * @porps handleInput: Function 親で定義された検索ロジック関数
 */
import FeatherIconButton from "@/components/atoms/FeatherIconButton";

export default {
  name: "M.SearchForm",
  components: {
    FeatherIconButton,
  },
  props: {
    placeholder: {
      type: String,
      required: true,
    },
    keyword: {
      type: String,
      default: "",
    },
    handleInput: {
      type: Function,
      required: true,
    },
  },
  computed: {
    isInput() {
      return this.keyword.length > 0;
    },
  },
  methods: {
    deleteWord() {
      this.handleInput("");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/vuexy/components/vxAutoSuggest.scss";

.search-form-box {
  position: relative;

  .search-form {
    font-family: $aisea-font-family;
    line-height: 18px;
    width: 360px;
    margin: 0 auto;
  }

  .search-form-x-icon {
    position: absolute;
    right: 18px;
    color: $aisea-pure-white;
    border-radius: 3px;
    z-index: 10;
    visibility: hidden;
  }

  .search-form-x-icon.visible {
    visibility: visible;

    &:hover {
      background-color: #6a717d;
    }

    &:active {
      background-color: #8b8e97;
    }
  }
}
</style>
